import { inject } from '@angular/core';
import { TeamsService } from '@teams/infra';
import { Observable } from 'rxjs';
import { LeaveTeamPathParams } from '@core-http';

export class LeaveTeamCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  leave(teamId: string): Observable<void> {
    const pathParams: LeaveTeamPathParams = { teamId };

    return this.teamsService.leaveTeam(pathParams);
  }
}
